import { Util } from '../utils/Commom';
function setEvent(options, chart) {
    var newOptions = Util.omit(options, ['onChange', 'onHide', 'onShow']);
    if (options.onChange) {
        newOptions.onChange = function (obj) {
            options.onChange(obj, chart);
        };
    }
    if (options.onHide) {
        newOptions.onHide = function (obj) {
            options.onHide(obj, chart);
        };
    }
    if (options.onShow) {
        newOptions.onShow = function (obj) {
            options.onShow(obj, chart);
        };
    }
    return newOptions;
}
export var process = function (chart, config) {
    var cTooltip = Util.deepClone(config.tooltip);
    if (Util.isNil(cTooltip) || cTooltip === false || cTooltip.show === false) {
        return chart.tooltip(false);
    }
    var options = Util.omit(cTooltip, ['show']);
    return chart.tooltip(setEvent(options, chart));
};
//# sourceMappingURL=setTooltipConfig.js.map